// Expense (gebyr) 
export const DOSE_PRICE_FORTNIGHT = 114.4;
export const DOSE_PRICE_YEARLY = DOSE_PRICE_FORTNIGHT * 26;

// This value comes from https://apotek.atlassian.net/wiki/spaces/AP/pages/98238672/Prisberegner+for+dosispakket+medicin+-+form+l+og+beskrivelser
export const EXPENSE_FACTOR = 105911843.0 / 123001985.0;


export interface CtrThreshold {
    min: number;
    max: number;
    factor: number;
}

export interface CtrThresholdPeriod {
    validFrom: Date;
    validTo: Date;
    thresholds: CtrThreshold[];
}

export const CTR_THRESHOLDS: CtrThresholdPeriod[] = [
    {
        validFrom: new Date('2022-01-01T00:00:00.000+01:00'),
        validTo: new Date('2023-01-01T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1020, factor: 0},
            {min: 1020, max: 1705, factor: 0.5},
            {min: 1705, max: 3700, factor: 0.75},
            {min: 3700, max: 20091, factor: 0.85},
            {min: 20091, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2023-01-01T00:00:00.000+01:00'),
        validTo: new Date('2023-04-03T00:00:00.000+02:00'),
        thresholds: [
            {min: 0, max: 1045, factor: 0},
            {min: 1045, max: 1750, factor: 0.5},
            {min: 1750, max: 3795, factor: 0.75},
            {min: 3795, max: 20636, factor: 0.85},
            {min: 20636, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2023-04-03T00:00:00.000+02:00'),
        validTo: new Date('2023-11-02T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1045, factor: 0},
            {min: 1045, max: 1750, factor: 0.5},
            {min: 1750, max: 3795, factor: 0.75},
            {min: 3795, max: 11570, factor: 0.85},
            {min: 11570, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2023-11-02T00:00:00.000+02:00'),
        validTo: new Date('2024-01-01T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1045, factor: 0},
            {min: 1045, max: 1750, factor: 0.5},
            {min: 1750, max: 3795, factor: 0.75},
            {min: 3795, max: 18870, factor: 0.85},
            {min: 18870, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2024-01-01T00:00:00.000+01:00'),
        validTo: new Date('2025-01-01T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1075, factor: 0},
            {min: 1075, max: 1805, factor: 0.5},
            {min: 1805, max: 3915, factor: 0.75},
            {min: 3915, max: 21298, factor: 0.85},
            {min: 21298, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2025-01-01T00:00:00.000+01:00'),
        validTo: new Date('2026-01-01T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1110, factor: 0},
            {min: 1110, max: 1865, factor: 0.5},
            {min: 1865, max: 4055, factor: 0.75},
            {min: 4055, max: 22055, factor: 0.85},
            {min: 22055, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    },
    {
        validFrom: new Date('2026-01-01T00:00:00.000+01:00'),
        validTo: new Date('2027-01-01T00:00:00.000+01:00'),
        thresholds: [
            {min: 0, max: 1135, factor: 0},
            {min: 1135, max: 1910, factor: 0.5},
            {min: 1910, max: 4155, factor: 0.75},
            {min: 4155, max: 22596, factor: 0.85},
            {min: 22596, max: Number.MAX_SAFE_INTEGER, factor: 1}
        ]
    }
];

export type Insurance = 'NONE' | 'NOT_MEMBER' | 'INACTIVE_MEMBER' | 'GROUP_1' | 'GROUP_2' | 'GROUP_5';

export const INSURANCE_REIMBURSEMENT_FACTORS: Readonly<Record<Insurance, number>> = Object.freeze({
    'NONE': 0,
    'NOT_MEMBER': 0,
    'INACTIVE_MEMBER': 0,
    'GROUP_1': 1,
    'GROUP_2': 1,
    'GROUP_5': 0.5
});
